// extracted by mini-css-extract-plugin
export default {"container":"Card_container__l4Sz7","title":"Card_title__f34MZ","content":"Card_content__TtxNf"};